import { NewMessageFormData } from '@src/main/modules/messages/ui/mailbox/components/new-message/types/NewMessageFormData';
import FloatLabelInput from '@src/main/shared/ui/components/input/FloatLabelInput';
import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
  control: Control<NewMessageFormData>;
  styles: Record<string, string>;
}

export const SubjectInput: FC<Props> = ({ control, styles }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="subject"
      control={control}
      rules={{ required: t('messages.validations.required') }}
      render={({ field, fieldState }) => (
        <FloatLabelInput
          label={t('messages.mailbox.subject')}
          value={field.value}
          onChange={field.onChange}
          error={fieldState.error?.message}
          className={styles['form-input']}
        />
      )}
    />
  );
};
